import React, { useState, useCallback, useEffect } from 'react';
import { TableContainer } from '@nile/components';
import { ClientFallback } from '@nile/components/src/Pebbles/clientVisibility';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';
import TableView from '@nile/banyan/src/Pages/ServiceCatalog/TableView';
import ActionCell from './ActionCell';

const AssociatedClientsWrapper = styled.div`
  width: 600px;
  border: 1px solid #e3e3e3;
  .unFreezeContent {
    margin-left: 0;
    max-height: fit-content !important;
  }
`;

function AssociatedClientsList(props) {
  const { clientList, updateClientList } = props;
  const [bulkSelectedRecords, setBulkSelectedRecords] = useState([]);
  const [columnGroup, setColumnGroup] = useState([
    { Header: 'CLIENTS', columns: [] }
  ]);
  useEffect(() => {
    const columns = [
      {
        Header: 'CLIENTS',
        accessor: 'name',
        type: 'Logo',
        width: 20,
        id: 'CLIENT_LOGO',
        disableResizing: false,
        className: 'sticky',
        field: { label: '', name: 'logo' },
        editable: false,
        actions: null,
        disableSortBy: true,
        disableFilters: true
      },
      {
        Header: 'CLIENTS',
        accessor: 'name',
        type: 'Text',
        id: 'CLIENTS',
        disableResizing: false,
        className: 'sticky',
        field: { label: 'CLIENTS', name: 'clients' },
        editable: false,
        actions: null,
        disableSortBy: true,
        disableFilters: true
      },
      {
        Header: 'REMOVAL',
        accessor: 'name',
        type: 'Action',
        id: 'REMOVE',
        width: 100,
        disableResizing: false,
        className: 'sticky',
        field: { label: '', name: 'removeAction' },
        editable: false,
        actions: getActions({ name: 'removeAction' }),
        disableSortBy: true,
        disableFilters: true
      }
    ];
    setColumnGroup([{ Header: 'Name', columns }]);
  }, [clientList]);
  const setRecords = (items) => {
    setBulkSelectedRecords(items);
  };
  const context = {
    setRecords: setRecords
  };

  /**
   * Mthod to remove the association from table
   * Both bulk selection and row deletion uses this method.
   * @param {array} itemsToFilter
   */

  const removeClientAssociation = (itemsToFilter = []) => {
    const selectedItems = clientList.filter(
      (client) =>
        !itemsToFilter.some(
          (clientToRemove) => client.accountId === clientToRemove.accountId
        )
    );
    updateClientList(selectedItems);
  };
  const getActions = (field) => {
    switch (field?.name) {
      case 'removeAction':
        return {
          onClick: removeClientAssociation
        };
      default:
        return null;
    }
  };
  const defaultColumnCells = {
    Action: ActionCell,
    Logo: ClientFallback
  };
  return (
    <AssociatedClientsWrapper>
      {bulkSelectedRecords.length > 0 ? (
        <div className="m8 flex">
          <div className="mlauto flex center">
            <div className="mr8">{`${bulkSelectedRecords.length} selected`}</div>
            <Button
              onClick={removeClientAssociation.bind(this, bulkSelectedRecords)}
            >
              <FormattedMessage id="common.remove" />
            </Button>
          </div>
        </div>
      ) : (
        ''
      )}
      <TableContainer>
        <TableView
          context={context}
          columns={columnGroup}
          data={clientList}
          defaultColumnCells={defaultColumnCells}
          rowCount={clientList.length}
          refreshTable={() => {}}
          listInfo={{}}
        />
      </TableContainer>
    </AssociatedClientsWrapper>
  );
}

export default AssociatedClientsList;
